export default "__VITE_ASSET__D0lomz1g__"